import { buildQuery, parseQuery } from '@calendly/http-tools'
import { useLocation, useHistory } from 'react-router-dom'

export const useURLParams = () => {
  const location = useLocation()
  const history = useHistory()

  const setHistory = (newSearchParams) => {
    history.push({
      pathname: window.location.pathname,
      search: `?${newSearchParams.toString()}`,
    })
  }

  const findParam = (query) => new URLSearchParams(location.search).get(query)

  const addParam = (newQuery) => {
    const params = parseQuery(history.location.search)
    const search = buildQuery({ [newQuery]: true, ...params })
    setHistory(search)
  }

  const removeParam = (query) => {
    const params = parseQuery(history.location.search)
    if (Array.isArray(query)) {
      query.forEach((q) => delete params[q])
    } else {
      delete params[query]
    }
    setHistory(buildQuery({ ...params }))
  }

  const replaceParam = (newQuery, oldQuery) => {
    const params = parseQuery(history.location.search)
    delete params[oldQuery]
    const search = buildQuery({ [newQuery]: true, ...params })
    setHistory(search)
  }

  return {
    findParam,
    replaceParam,
    removeParam,
    addParam,
  }
}
